import { notification } from "antd";
import React from "react";
import { ToastContext } from "./context";

interface ToastContextProviderProps {
  children: React.ReactNode;
}

export const ToastContextProvider = ({
  children,
}: ToastContextProviderProps) => {
  const [api, contextHolder] = notification.useNotification();

  const open = (
    type: "info" | "success" | "error",
    message: string,
    description?: string
  ) => {
    if (type === "success") {
      api.success({
        message,
        description,
        placement: "bottomRight",
      });
      return;
    }
    if (type === "error") {
      api.error({
        message,
        description,
        placement: "bottomRight",
      });
      return;
    }
    api.info({
      message,
      description,
      placement: "bottomRight",
    });
  };
  return (
    <ToastContext.Provider value={{ open }}>
      {children}
      {contextHolder}
    </ToastContext.Provider>
  );
};
